import { ArrowRight } from 'lucide-react'

export function ArrowIcon() {
  return <ArrowRight aria-hidden="true" className="arrow-icon" strokeWidth={1.6} />
}
